<script lang="ts">
import {defineComponent} from 'vue'
import TicketLayouts from "@/components/Tickets/layouts/TicketLayouts.vue";
import ActionCard from "@/components/Tickets/ActionCard.vue";
import {mapActions, mapGetters} from 'vuex';

export default defineComponent({
  name: "TicketActions",
  components: {TicketLayouts, ActionCard},
  data() {
    return {
      // pagination
      currentPage: 1,
      perPage: 15,
      isTable: false,
      perPageOptions: [
        {value: 10, text: '10 на странице'},
        {value: 15, text: '15 на странице'},
        {value: 25, text: '25 на странице'},
        {value: 50, text: '50 на странице'}
      ],
      //
      actionParams: {
        title: "",
        name: "",
        parent_action_id: null,
        status_id: null,
        group_id: null,
        enabled: true,
        back_action_id: null
      },
      isOpenCreateActionModal: false,
      sidebarFields: [],
      isSidebarLoading: false,
      selectedAction: {},
      fields: [
        {key: 'id', label: '№', sortable: true},
        {key: 'date', label: 'Дата', sortable: true},
        {key: 'name', label: 'Название'},
        {key: 'enabled', label: 'Включено',},
        {key: 'username', label: 'Кем создан',},
        {key: 'title', label: 'Заголовок',},
        {key: 'status', label: 'Статус',},
        {key: "parent_action", label: "Родительское действие"},
        {key: "back_action", label: "Возвратное"},
        {key: "actions", label: "Действия"},
      ],
      treeConfig: {
        nodeWidth: 230,//+
        linkSeparation: 100, //+
        nodeHeight: 50, //+
        levelHeight: 370,
        buildMode: 'children',
        offsetRight: 400
      }
    }
  },
  computed: {
    ...mapGetters('moduleTickets', ['ticketActions', 'groupOptions', 'statusOptions', 'parentActionOptions', 'isLoading', 'meta', 'links']),
    treeData() {
      return {
        children: this.buildTreeStructure()
      }
    }
  },
  methods: {
    ...mapActions('moduleTickets', ['getTicketGroups', 'getTicketStatuses', 'getTicketActions', 'createAction', 'updateAction', 'deleteAction']),
    buildTreeStructure() {
      if (!this.ticketActions || this.ticketActions.length === 0) {
        return []
      }

      // Создаем мапу всех действий по ID
      const actionsMap = new Map()
      const rawActions = []

      // Собираем все действия из пагинированных данных
      this.ticketActions.forEach(action => {
        const actionData = {
          ...action,
          _key: `action-${action.id}`,
          name: action.name,
          children: []
        }
        actionsMap.set(action.id, actionData)
        rawActions.push(action)
      })

      // Строим дерево на основе parent_action_id
      const roots = []
      rawActions.forEach(action => {
        const actionNode = actionsMap.get(action.id)

        // Если есть родитель, добавляем к нему как ребенка
        if (action.parent_action_id && actionsMap.has(action.parent_action_id)) {
          const parent = actionsMap.get(action.parent_action_id)
          parent.children.push(actionNode)
        } else {
          // Иначе это корневой элемент
          roots.push(actionNode)
        }
      })

      return roots
    },
    async createTicketAction() {
      try {
        await this.createAction(this.actionParams);
        this.$bvModal.hide('create-action');
        this.actionParams = {
          title: "",
          name: "",
          parent_action_id: null,
          status_id: null,
          group_id: null,
          enabled: true,
          back_action_id: null
        }
      } catch (e) {
        this.$bvToast.toast(e.message || 'Произошла ошибка', {
          title: e.message ? "Валидация" : "Ошибка сервера",
          variant: "danger",
        })
      }
    },
    async openEditSidebar(item) {
      this.isSidebarLoading = true
      if (!this.groupOptions.length) {
        await this.getTicketGroups()
      }
      if (!this.statusOptions.length) {
        await this.getTicketStatuses()
      }
      this.isSidebarLoading = false
      this.sidebarFields = [
        {
          key: 'name',
          label: 'Название',
          type: 'text',
          placeholder: 'Введите название',
          required: true
        },
        {
          key: "title",
          label: "Заголовок",
          type: "text",
          placeholder: "Введите заголовок"
        },
        {
          key: 'group_id',
          label: 'Название группы',
          type: 'select',
          placeholder: 'Выберите название',
          options: this.groupOptions,
          required: true
        },
        {
          key: 'status_id',
          label: 'Статус',
          type: 'select',
          placeholder: 'Выберите статус',
          options: this.statusOptions,
          required: true
        },
        {
          key: 'parent_action_id',
          label: 'Выберите родительское действие',
          type: 'select',
          placeholder: 'Выберите действие',
          options: this.parentActionOptions,
          required: true
        },
        {
          key: 'back_action_id',
          label: 'Выберите возвратное действие',
          type: 'select',
          placeholder: 'Выберите действие',
          options: this.parentActionOptions,
        },
        {
          key: 'enabled',
          label: 'Включено',
          type: 'checkbox',
          default: true
        },
      ]
      this.selectedAction = {
        ...item,
        _original: item,
        enabled: item.enabled === "Да"
      }
      this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
    },
    async handleSaveAction(formData) {
      this.isSidebarLoading = true
      try {
        await this.updateAction({id: this.selectedAction.id, formData});
        this.$bvToast.toast('Действие успешно обновлено', {
          title: "Успех",
          variant: "success",
        })
        this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
        this.selectedCategory = null
      } catch (e) {
        this.$bvToast.toast(e.response?.message || e.response?.data?.message || 'Произошла ошибка', {
          title: "Ошибка сервера",
          variant: "danger",
        })
      } finally {
        this.isSidebarLoading = false;
      }
    },
    async handleDeleteAction(action) {
      try {
        await this.deleteAction(action.id);
      } catch (e) {
        this.$bvToast.toast(e.response?.message || e.response?.data?.message || 'Произошла ошибка', {
          title: "Ошибка сервера",
          variant: "danger",
        })
      }
    },
    onPageChange(page) {
      this.currentPage = page
      this.getTicketActions({page: page, per_page: this.perPage})
      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    changePerPage() {
      this.currentPage = 1
      this.getTicketActions({page: 1, per_page: this.perPage})
    }
  },
  watch: {
    isOpenCreateActionModal: {
      handler(value) {
        if (value) {
          this.getTicketGroups()
          this.getTicketStatuses()
        }
      }
    },
    'meta.current_page': {
      handler(newPage) {
        if (newPage && this.currentPage !== newPage) {
          this.currentPage = newPage
        }
      }
    }
  },
  mounted() {
    this.getTicketActions({page: this.currentPage, per_page: this.perPage})
  },
})
</script>

<template>
  <TicketLayouts
      title="Действия"
      :sidebar-item="selectedAction"
      :sidebar-loading="isSidebarLoading"
      :sidebar-fields="sidebarFields"
      @sidebar-save="handleSaveAction"
  >
    <Breadcrumbs main="Tickets" title="Действие"/>
    <div class="container-fluid px-0">
      <div class="d-flex justify-content-end">
        <b-button variant="primary" class="mr-2" @click="isTable = !isTable">
          {{ isTable ? 'Сетка' : 'Таблица' }}
        </b-button>
        <b-button v-b-modal.create-action variant="success" @click="isOpenCreateActionModal = true">
          Создать
        </b-button>
      </div>
      <div class="tree-wrapper" v-if="!isTable">
      <div v-if="treeData && treeData.children && treeData.children.length > 0" class="tree-container ml-3">
        <TreeView
            :dataset="treeData"
            linkStyle="straight"
            direction="vertical"
            :config="treeConfig"
            :dragEnabled="false"
        >
          <template v-slot:node="{ node }">
            <div class="action-node" @click="openEditSidebar(node)">
              <div class="action-header">
                <span class="action-id">№{{ node.id }}</span>
                <span class="action-status" :class="node.enabled === 'Да' ? 'enabled' : 'disabled'">
                  {{ node.enabled }}
                </span>
              </div>
              <div class="action-title">{{ node.name }}</div>
              <div class="action-subtitle" v-if="node.title">{{ node.title }}</div>
              <div class="action-info">
                <div v-if="node.status" class="info-item">
                  <i class="fas fa-info-circle"></i> {{ node.status }}
                </div>
                <div v-if="node.username" class="info-item">
                  <i class="fas fa-user"></i> {{ node.username }}
                </div>
              </div>
              <div class="action-buttons">
                <button class="btn-edit" @click.stop="openEditSidebar(node)">
                  Редактировать
                </button>
                <button class="btn-delete" @click.stop="handleDeleteAction(node)">
                  Удалить
                </button>
              </div>
            </div>
          </template>
        </TreeView>
      </div>
      </div>
      <div v-else-if="isTable">
        <b-table
            responsive
            show-empty
            stacked="md"
            :items="ticketActions"
            striped
            bordered
            :fields="fields"
        >
          <template #cell(actions)="{item}">
            <b-button
                class="mr-2"
                variant="primary"
                size="sm"
                @click="openEditSidebar(item)"
            >
              <i class="fas fa-edit"></i> Редактировать
            </b-button>
            <b-button
                variant="danger"
                size="sm"
                @click="handleDeleteAction(item)"
            >
              <i class="fas fa-trash"></i> Удалить
            </b-button>
          </template>
        </b-table>
      </div>
      <div v-else class="no-data">
        Нет данных для отображения
      </div>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="text-muted">
          Показано с {{ meta.from }} по {{ meta.to }} из {{ meta.total }} записей
        </div>
        <div class="d-flex align-items-center gap-2">
          <b-form-select
              v-model="perPage"
              :options="perPageOptions"
              size="sm"
              @change="changePerPage"
              class="mr-2"
          ></b-form-select>
          <b-pagination
              v-model="currentPage"
              :total-rows="meta.total"
              :per-page="meta.per_page"
              @change="onPageChange"
              align="right"
              size="sm"
          ></b-pagination>
        </div>
      </div>
    </div>
    <b-modal id="create-action" hide-footer title="Создать действие">
      <div v-if="isLoading" class="d-flex justify-content-center h-100">
        <b-spinner></b-spinner>
      </div>
      <b-form @submit.prevent="createTicketAction" v-else>
        <b-form-input v-model="actionParams.name" placeholder="Название"/>
        <b-form-input v-model="actionParams.title" placeholder="Заголовок" class="mt-3"/>
        <b-form-group class="mt-3" label="Выберите группу" label-for="group">
          <b-form-select id="group" v-model="actionParams.group_id" :options="groupOptions"
          ></b-form-select>
        </b-form-group>
        <b-form-group class="mt-3" label="Выберите статус" label-for="status">
          <b-form-select id="status" v-model="actionParams.status_id" :options="statusOptions"
          ></b-form-select>
        </b-form-group>
        <b-form-group class="mt-3" label="Выберите родительское действие" label-for="parent-action">
          <b-form-select id="parent-action" v-model="actionParams.parent_action_id" :options="parentActionOptions"
          ></b-form-select>
        </b-form-group>
        <b-form-group class="mt-3" label="Выберите возвратное действие" label-for="back-action">
          <b-form-select id="back-action" v-model="actionParams.back_action_id" :options="parentActionOptions"
          ></b-form-select>
        </b-form-group>
        <div class="mt-3 d-flex spacing gap-1">
          <b-form-checkbox v-model="actionParams.enabled" :value="actionParams.enabled"></b-form-checkbox>
          <p>Включено</p>
        </div>
        <b-button class="mt-3 w-100" type="submit">Создать</b-button>
      </b-form>
    </b-modal>
  </TicketLayouts>
</template>

<style scoped lang="scss">

.tree-wrapper {
  overflow-x: auto;
  width: 100%;
}

.tree-container {
  overflow: visible;
  max-height: calc(100vh - 200px);
  //width: 100%;
  //max-width: calc(100vw - 0px);
  background: #f8f9fa;
  padding: 20px;
  border-radius: 10px;
  min-width: max-content;
  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 0px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;

    &:hover {
      background: #555;
    }
  }
}

.no-data {
  text-align: center;
  padding: 40px;
  color: #999;
  font-size: 16px;
  margin: 20px 0;
}

::v-deep .tree-view {
  min-height: 600px;
  width: max-content;
  min-width: max-content;
}

.action-node {
  background: white;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 150px;
  max-width: 200px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(115, 102, 255, 0.3);
    transform: translateY(-2px);
  }

  .action-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0e0e0;

    .action-id {
      font-size: 12px;
      font-weight: bold;
      color: #7366ff;
    }

    .action-status {
      font-size: 10px;
      padding: 3px 8px;
      border-radius: 12px;

      &.enabled {
        background: #28a745;
        color: white;
      }

      &.disabled {
        background: #6c757d;
        color: white;
      }
    }
  }

  .action-title {
    font-size: 14px;
    font-weight: 600;
    color: #2b2b2b;
    margin-bottom: 5px;
    word-wrap: break-word;
  }

  .action-subtitle {
    font-size: 11px;
    color: #808080;
    margin-bottom: 10px;
    word-wrap: break-word;
  }

  .action-info {
    margin-bottom: 10px;

    .info-item {
      font-size: 10px;
      color: #666;
      margin-bottom: 4px;
      display: flex;
      align-items: center;
      gap: 5px;

      i {
        color: #7366ff;
        width: 12px;
      }
    }
  }

  .action-buttons {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 10px;

    button {
      width: 100%;
      padding: 6px 10px;
      border: none;
      border-radius: 6px;
      font-size: 12px;
      cursor: pointer;
      transition: all 0.2s;

      &.btn-edit {
        background: #7366ff;
        color: white;

        &:hover {
          background: #5a4fd4;
        }
      }

      &.btn-delete {
        background: #dc3545;
        color: white;

        &:hover {
          background: #c82333;
        }
      }
    }
  }
}
</style>